import React from "react";

function Contact() {
  return (
    <>
      <div className="mt-[8rem] mb-[6rem] mx-4 md:flex md:justify-center md:gap-10 lg:gap-[3rem] xl:gap-[5rem] lg:mx-[4rem] 2xl:gap-[8rem] 2xl:mx-[8rem]">
        {/* left side */}
        <div className="flex flex-col justify-center items-center md:w-1/2">
          <h1 className="text-[2rem] uppercase font-bold mb-6">Contact</h1>
          <p className="text-[#b7b7b7] text-center md:mb-8 lg:mb-12">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur
            velit, dignissimos accusamus esse quos dolor ducimus dolores dolore,
            nostrum perferendis voluptatibus est a voluptate mollitia ratione,
            in fugiat rem odio!
          </p>
          <div className="my-3 text-[1rem] flex flex-col justify-center items-center">
            <p className="text-[1.2rem]">Address</p>
            <p className="text-[#b7b7b7]">11111 St Surrey BC Canada</p>
          </div>
          <div className="my-3 text-[1rem] flex flex-col justify-center items-center">
            <p className="text-[1.2rem]">Phone</p>
            <p className="text-[#b7b7b7]">777-777-7777</p>
            <div className="my-3 text-[1rem] flex flex-col justify-center items-center">
              <p className="text-[1.2rem]">E-mail</p>
              <p className="text-[#b7b7b7] mb-8" mailto="email@email.com">
                mailto:email@email.com
              </p>
            </div>
          </div>
        </div>
        {/* right side */}
        <form className="flex flex-col justify-center items-center md:w-1/2 md:px-6 md:py-8 rounded-md md:shadow-2xl md:bg-[#2e2e2e] lg:px-[2rem] xl:px-[4rem] 2xl:px-[6rem]">
          <h2 className="text-[2rem] uppercase font-bold mb-8 md:bg-[#2e2e2e]">
            Contact Form
          </h2>
          <input
            className="my-2 border-b p-2 w-[100%] focus:outline-none md:bg-[#2e2e2e]"
            type="text"
            placeholder="Your name"
          />
          <input
            className="my-2 border-b p-2 w-[100%] focus:outline-none md:bg-[#2e2e2e]"
            type="text"
            placeholder="Your phone"
          />
          <input
            className="my-2 border-b p-2 w-[100%] focus:outline-none md:bg-[#2e2e2e]"
            type="text"
            placeholder="Your email"
          />
          <input
            className="my-2 border-b p-2 h-[6rem] w-[100%] resize-none align-top focus:outline-none md:bg-[#2e2e2e]"
            type="textarea"
            placeholder="Your message"
          />
          <button className="border py-4 px-10 my-8 rounded-md hover:bg-black">
            Send Message
          </button>
        </form>
      </div>
    </>
  );
}

export default Contact;
